import { ShaderChunk } from 'three';

import commonGlsl from './common.glsl?raw';
import atmosphereGlsl from './atmosphere.glsl?raw';
import lightingGlsl from './lighting.glsl?raw';
import brushGlsl from './brush.glsl?raw';
import facadeGlsl from './facade.glsl?raw';
import fieldsGlsl from './fields.glsl?raw';
import fieldTextureGlsl from './fieldTexture.glsl?raw';
import fieldColourGlsl from './fieldColour.glsl?raw';
import hashGlsl from './hash.glsl?raw';
import painterProjectionGlsl from './painterProjection.glsl?raw';
import patternsGlsl from './patterns.glsl?raw';
import patternMasonryGlsl from './patternMasonry.glsl?raw';
import patternTimberGlsl from './patternTimber.glsl?raw';
import patternRoofGlsl from './patternRoof.glsl?raw';
import patternClothGlsl from './patternCloth.glsl?raw';
import patternPavingGlsl from './patternPaving.glsl?raw';
import shoreBandGlsl from './shoreBand.glsl?raw';
import openWaterGlsl from './openWater.glsl?raw';
import cloudBankGlsl from './cloudBank.glsl?raw';
import grimeGlsl from './grime.glsl?raw';
import citizenSkinGlsl from './citizenSkin.glsl?raw';

const chunks = ShaderChunk as Record<string, string>;

export function registerShaderChunks(): void {
  chunks['ams_common'] = commonGlsl;
  chunks['ams_atmosphere'] = atmosphereGlsl;
  chunks['ams_lighting'] = lightingGlsl;
  chunks['ams_brush'] = brushGlsl;
  chunks['ams_facade'] = facadeGlsl;
  chunks['ams_fields'] = fieldsGlsl;
  chunks['ams_hash'] = hashGlsl;
  chunks['ams_field_texture'] = fieldTextureGlsl;
  chunks['ams_field_colour'] = fieldColourGlsl;
  chunks['ams_painter_projection'] = painterProjectionGlsl;
  chunks['ams_patterns'] = patternsGlsl;
  chunks['ams_pattern_masonry'] = patternMasonryGlsl;
  chunks['ams_pattern_timber'] = patternTimberGlsl;
  chunks['ams_pattern_roof'] = patternRoofGlsl;
  chunks['ams_pattern_cloth'] = patternClothGlsl;
  chunks['ams_pattern_paving'] = patternPavingGlsl;
  chunks['ams_shore_band'] = shoreBandGlsl;
  chunks['ams_open_water'] = openWaterGlsl;
  chunks['ams_cloud_bank'] = cloudBankGlsl;
  chunks['ams_grime'] = grimeGlsl;
  chunks['ams_citizen_skin'] = citizenSkinGlsl;
}

export function isChunksRegistered(): boolean {
  return 'ams_common' in chunks;
}
